<template>
    <div>
        <div class="form-box">
            <el-form ref="form" inline :model="queryForm" label-width="80px" style="text-align: center">
                <el-form-item>
                    <el-input v-model="queryForm.name" clearable placeholder="Forms Name"></el-input>
                </el-form-item>

                <el-form-item>
                    <el-input v-model="queryForm.unitNo" clearable placeholder="Unit No."></el-input>
                </el-form-item>

                <el-form-item>
                    <el-input v-model="queryForm.paymentId" clearable placeholder="Payment ID"></el-input>
                </el-form-item>

                <el-form-item>
                    <el-select v-model="queryForm.status" placeholder="Status">
                        <el-option
                                v-for="item in [
                                    {value:2,label:'Pending'},
                                    {value:3,label:'Rework'},
                                    {value:4,label:'Approved'},
                                    {value:5,label:'Rejected'},
                                ]"
                                :key="item.value+'a-s-c'"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>

                <payment-status-filter :status.sync="queryForm.payStatus"></payment-status-filter>

                <el-form-item>
                    <el-date-picker
                            clearable
                            v-model="queryForm.payed"
                            type="daterange"
                            format="dd-MM-yyyy"
                            value-format="yyyy-MM-dd"
                            start-placeholder="Paid Date"
                            end-placeholder="Paid Date">
                    </el-date-picker>
                </el-form-item>

                <el-button type="primary" @click="loadData" icon="el-icon-search" size="medium" circle></el-button>
                <el-button type="primary" @click="exportData" icon="el-icon-download" size="medium" circle></el-button>
            </el-form>
        </div>

        <el-table
                v-loading="loading"
                fit
                stripe
                class="data-table"
                :data="data">
            <el-table-column
                    label="Action">
                <template slot-scope="s">
                    <el-button type="primary" size="small" @click="downloadPdf(s.row.id)">PDF</el-button>
                </template>
            </el-table-column>

            <el-table-column type="expand">
                <template slot-scope="s">
                    <a v-for="item in s.row.files" target="_blank" :href="item.path">
                        {{item.name}}
                    </a>
                </template>
            </el-table-column>

            <el-table-column
                    header-align="center"
                    align="center"
                    v-for="item in [
                        {prop:'bid',label:'Order ID',wth:'160px'},
                        {prop:'paymentBid',label:'Payment ID',wth:'160px'},
                        {prop:'eazableCode',label:'QR code',wth:'170px'},
                        {prop:'unitName',label:'Unit',wth:'140px'},
                        {prop:'name',label:'Forms Name',wth:'200px'},
                        {prop:'status',label:'Status',wth:'100px',fmt:statusFmt},
                        {prop:'amount',label:'Amount',wth:'140px'},
                        {prop:'created',label:'Application date',fmt:selfTimeFormat,wth:'150px'},
                        {prop:'approval',label:'Approval date',fmt:selfTimeFormat,wth:'160px'},
                        {prop:'payMethod',label:'Payment method',fmt:paymentMethodFormat,wth:'140px'},
                        {prop:'payStatus',label:'Status of payment',fmt: payStatusFormat,wth:'150px'},
                        {prop:'payedDate',label:'Paid Date',fmt:selfTimeFormat,wth:'160px'},
                        {prop:'settlement',label:'Settlement Status',fmt:settlementStatusFormat,wth:'140px'},
                    ]"
                    :formatter="item.fmt"
                    :prop="item.prop"
                    :width="item.wth"
                    :label="item.label"
                    :key="item.label">
            </el-table-column>
        </el-table>

        <div class="page">
            <el-pagination @current-change="loadData"
                           :page-size="page.size"
                           :current-page.sync="page.page"
                           :page-count="page.totalPage"
                           layout="prev, pager, next"
                           :total="data.total">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import {formsOrders, exportFormsOrders, getOrderPdf} from '@/api/FormAPI'
    import {excelRequestRequest, pdfRequestRequest} from "@/utils/ApiUtils";
    import PaymentStatusFilter from "@/components/PaymentStatusFilter";

    export default {
        name: "FormsOrders",
        components: {PaymentStatusFilter},
        data: function () {
            return {
                queryForm: {},
                loading: false,
                data: [],
                page: {'page': 1, 'size': 10, 'totalPage': 1, 'total': 0},
            }
        },
        methods: {
            loadData() {
                this.$pageUtils(this, formsOrders)
            },
            exportData() {
                excelRequestRequest(this, exportFormsOrders);

            },
            statusFmt(row, cell, val) {
                return {
                    2: 'Pending',
                    3: 'Rework',
                    4: 'Approved',
                    5: 'Rejected',

                }[val]
            },
            saveData() {
                const action = this.form.id ? null : null;
                this.$refs['form'].validate((valid) => {
                    const form = this.$copy(this.form)
                    delete form.icon
                    if (valid) {
                        action(form)
                            .then(() => {
                                this.loadData()
                                this.dialogVisible = false
                            })
                    }
                })
            },
            downloadPdf(id) {
                pdfRequestRequest(id, getOrderPdf)
            }
        },
        mounted() {
            this.loadData()
        }
    }
</script>

<style scoped>

</style>
